import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      is: {
        translation: require('../config/is.json'),
      },
      en: {
        translation: require('../config/en.json'),
      },
    },
    // lng: DEFAULT_LANGUAGE,
    fallbackLng: 'is',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path', 'querystring', 'cookie'],
      lookupFromPathIndex: 0,
      lookupQuerystring: 'lng',
      caches: ['cookie'],
    },
  });

export default i18n;
